/**
 * fw-collection-sort.js
 * Sortiert Produkt-Cards in der Collection-Liste:
 *   data-available="true"  → priority 1 (oben)
 *   alles andere           → priority 2 (unten)
 *
 * Beobachtet documentElement, damit auch Shopify Search & Discovery
 * Full-Section-Replacements abgefangen werden.
 */
(function () {
  'use strict';

  function getPriority(card) {
    return card.dataset.available === 'true' ? 1 : 2;
  }

  function sortGrid() {
    // Alle Cards in allen Grids der Collection-Liste markieren (nicht nur das erste
    // Grid) — bei Infinite-Scroll/Facets rendert Impact mehrere product-list-Blöcke.
    const cards = document.querySelectorAll('.collection__results product-card');
    if (!cards.length) return;
    cards.forEach(card => {
      card.setAttribute('data-priority', getPriority(card));
    });
  }

  let timer;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(sortGrid, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortGrid);
  } else {
    sortGrid();
  }

  window.addEventListener('load', sortGrid);
})();
